import { render, staticRenderFns } from "./NewProjectModal.vue?vue&type=template&id=b2150fd2&scoped=true&"
import script from "./NewProjectModal.vue?vue&type=script&lang=js&"
export * from "./NewProjectModal.vue?vue&type=script&lang=js&"
import style0 from "./NewProjectModal.vue?vue&type=style&index=0&id=b2150fd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2150fd2",
  null
  
)

export default component.exports